import React from "react";
import { Building2, Users, Award } from "lucide-react";
import AudienceLanding from "../components/AudienceLanding";

export default function Automotive() {
  return (
    <AudienceLanding
      audienceSlug="automotive"
      landingParam="automotive"
      registerAudienceParam="automotive"
      testidPrefix="automotive-landing"
      hero={{
        overline: "PREMIUM AI ACADEMY FOR AUTO DEALERS",
        headline: (
          <>
            Teach your<br />
            dealership to<br />
            <span className="text-fc-red">build with AI.</span>
          </>
        ),
        subhead: "Operator-led programs for every role in the store — Marketing, Sales, Service, Operations, and the Executive seat. No theory. The actual tools, prompts, and dashboards running at the top 1% of dealerships.",
        heroImage: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=2000&q=80",
      }}
      stats={[
        { icon: Building2, value: "500+", label: "Dealerships" },
        { icon: Users, value: "10,000+", label: "Professionals Trained" },
        { icon: Award, value: "5", label: "AI Departments" },
      ]}
      testimonials={[
        { name: "Carla Vance", role: "GM, Heritage Cadillac", quote: "We rebuilt our BDC around the Sales AI Co-Pilot in three weeks. Close rate went from 14% to 22%." },
        { name: "Marc Berlinger", role: "Dealer Principal, BerlinerAuto", quote: "I used to hate AI talks. Freddy is operators teaching operators. Everything is shippable Monday morning." },
        { name: "Tasha Brooks", role: "VP Marketing, Northland Auto Group", quote: "Cut our content production cost by 60% in 30 days. The frameworks here are gold." },
      ]}
      featuredHeadline={
        <>Where dealers <span className="text-fc-red">start.</span></>
      }
    />
  );
}
